import React from 'react';

export default () => (
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
<path fillRule="evenodd" clipRule="evenodd" d="M11.4229 0.244078C11.7484 0.569515 11.7484 1.09715 11.4229 1.42259L6.42291 6.42259C6.09748 6.74803 5.56984 6.74803 5.2444 6.42259L0.244402 1.42259C-0.0810356 1.09715 -0.0810356 0.569515 0.244402 0.244078C0.569839 -0.0813592 1.09748 -0.0813592 1.42291 0.244078L5.83366 4.65482L10.2444 0.244078C10.5698 -0.0813592 11.0975 -0.0813592 11.4229 0.244078Z" fill="currentColor"/>
</svg>
)
